import { ThemeOptions } from '@mui/material';
import { createContext } from 'react';

export const ThemeContext = createContext({
  themeName: 'dark',
  setThemeName: (newThemeName: string) => {},
  changeTheme: (options: ThemeOptions) => {}
});
